<template>
    <nav :class="['navbar', $style.homeHeader]">
        <div :class="['navbar-brand', $style.contentWrapper]">
            <a :class="['navbar-item', $style.headerContents]" href="/">Home</a>
            <a :class="['navbar-item', $style.headerContents]">About</a>
            <a :class="['navbar-item', $style.headerContents]">Help</a>
        </div>
    </nav>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    @Component({})
    export default class HomeHeader extends Vue {}
</script>

<style lang="scss" module>
    .homeHeader {
        &#{&} {
            background-color: #444f51;
            min-height: 2.8rem;
            height: 44px;
            width: 100%;
        }
    }

    .contentWrapper {
        padding-bottom: 10px;
        margin-left: 4px;
    }

    .headerContents {
        &#{&}#{&}#{&} {
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            line-height: 19px;
            padding: 12px 40px;
        }
    }
</style>
